import { StringUtil } from '@ddt-web/generic-utils';

import { CommonDataUtil } from '../../data-mapper/utils';
import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { BaseChartWorker } from '../common';


/**
 * CompositeStackedBarChartWorker: chart worker specific to a Composite Stacked Bar Chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class CompositeStackedBarChartWorker extends BaseChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
		this.initChartForWeb();
	}

	private initChartForWeb(): void {
		this.config.yAxis.max = undefined;
		this.config.yAxis.visible = false;
		this.config.plotOptions.series.borderWidth = 0;
		if (this.highChartsAttributes.customAttributes?.barWidth) {
			this.config.plotOptions.bar.pointWidth = this.highChartsAttributes.customAttributes.barWidth;
		}
	}


	public transformData(): void {
		const seriesColors = this.highChartsAttributes.colors ? this.highChartsAttributes.colors : CommonDataUtil.getPortfolioColors();
		const tableData = this.highChartsAttributes.tabData.tableData[0];
		const seriesCategories = tableData.headersX.map(cell => cell.formattedValue);
		const totalPortfolios = tableData.cells.length;
		const seriesData = seriesCategories.map((cat, index) => {
			const count = tableData.cells.filter(cells => cells[index].rawValue).length;
			return {
				name: cat,
				data: [{ y: count, tooltip: `<b>${StringUtil.escapeHtml(cat)} </b><br> ${count} | ${((count / totalPortfolios) * 100).toFixed(2)}%` }]
			};
		});

		this.config.colors = seriesColors;
		this.config.series = seriesData;
		this.config.xAxis.categories = seriesCategories;
	}
}
